import { FlexFlowWorkoutHomeCardListSkeleton } from '../flex-flow-workout-card-list/flex-flow-workout-card-list-skeleton'
import { Container, Row } from 'react-bootstrap'
import { FlexFlowWorkoutCardList } from 'src/component/flex-flow-workout-card-list/flex-flow-workout-card-list'
import { ForwardArrowLink } from 'src/component/forward-arrow-link/forward-arrow-link'
import { SectionTitle } from 'src/component/ui/section-title'
import { useFlexFlowWorkouts } from 'src/hook/use-workouts'

export const FlexFlowWorkouts = (): React.ReactElement => {
  const { data: workouts = [], isLoading } = useFlexFlowWorkouts({ pageSize: 3, page: 1 })

  if (!workouts && !isLoading) return <></>

  return (
    <Container className="text-black w-full pt-10 pb-12 flex flex-col gap-12">
      <Row className="flex flex-nowrap justify-between items-center gap-4">
        <SectionTitle>FLEX FLOW</SectionTitle>
        <div className="flex-shrink-0">
          <ForwardArrowLink text="See All" link="/flex-flow-workouts" theme="light" />
        </div>
      </Row>
      {isLoading ? <FlexFlowWorkoutHomeCardListSkeleton /> : <FlexFlowWorkoutCardList workouts={workouts} />}
    </Container>
  )
}
